import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import {
	fetchGamesSaga,
	fetchLiveScoresSaga,
	fetchChecksumsJSONSaga,
} from "apps/BUDWEISERPOTM/modules/sagas";
import {
	fetchChecksumsJSON,
	fetchGamesJSON,
	fetchPlayersJSON,
	subscribeToLiveScores,
} from "apps/BUDWEISERPOTM/modules/actions";
import {fetchPlayersSaga} from "apps/BUDWEISERPOTM/modules/sagas/players";
import {
	addVoteAction,
	getVotesAction,
	checkLocalVotes,
	saveLocalVotes,
} from "apps/BUDWEISERPOTM/modules/actions/votes";
import {
	addVoteSaga,
	getVotesSaga,
	checkLocalVotesSaga,
	saveLocalVotesSaga,
} from "apps/BUDWEISERPOTM/modules/sagas/votes";

export const projectSaga = function* (): SagaIterator {
	yield all([
		/**
		 * JSON's
		 */
		takeLatest(fetchGamesJSON, fetchGamesSaga),
		takeLatest(fetchPlayersJSON, fetchPlayersSaga),
		takeLatest(fetchChecksumsJSON, fetchChecksumsJSONSaga),
		takeLatest(addVoteAction, addVoteSaga),
		takeLatest(getVotesAction, getVotesSaga),
		takeLatest(checkLocalVotes, checkLocalVotesSaga),
		takeLatest(saveLocalVotes, saveLocalVotesSaga),
		/**
		 * LiveScores
		 * */
		takeLatest(subscribeToLiveScores, fetchLiveScoresSaga),
	]);
};

export * from "./games";
export * from "./liveScoring";
